'use client';

import PlayVideoIcon from 'components/icons/play-video';
import { withSuspense } from 'components/with-suspense';
import { useState } from 'react';
import './video-block.css';

const VideoSkeleton = <div className="animate-pulse"></div>;

export const VideoEmbed = withSuspense(
    (props: {
        content: any;
        contentAutoplay: any;
        posterImage: string;
        posterImageAltText: string;
        posterImageVisibility: boolean;
        url: string;
    }) => {

        const getYouTubeId = () => {
            const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
            // Pulls YT ID from url entered into component on builder
            const match = props.url ? props.url.match(regExp) : '';
            return match ? match[7] : null;
        };

        const youTubeId = getYouTubeId()

        const posterImage = props.posterImage
            ? props.posterImage
            : youTubeId
                ? `https://i.ytimg.com/vi/${youTubeId}/maxresdefault.jpg`
                : null;

        const mobileImage = props.posterImage
            ? props.posterImage
            : youTubeId
                ? `https://i.ytimg.com/vi/${youTubeId}/sddefault.jpg`
                : null;

        const srcSet = props.posterImage
            ? null // No need for srcSet if props.posterImage exists
            : [
                mobileImage ? `${mobileImage} 1280w` : null,
                posterImage ? `${posterImage} 2560w` : null,
            ]
                .filter(Boolean)
                .join(', ');

        const posterAlt = props.posterImageAltText;
        const hidePoster = props.posterImageVisibility;

        const [hasBeenClicked, setHasBeenClicked] = useState(false);
        const handlePosterClick = () => {
            setHasBeenClicked(true);
        };

        return (
            <div className="video-block">
                {posterImage && !hidePoster && (
                    <div className={`video-block-poster${hasBeenClicked ? ' video-is-active' : ''} ${
                        props.posterImage ? 'is-custom-image' : ''
                    }
          `}>
                        <img
                            width="1280"
                            height="720"
                            src={posterImage}
                            srcSet={srcSet || undefined }
                            sizes="(min-width: 990px) 50vw, 100vw"
                            className="video-block-poster-image"
                            alt={posterAlt ? posterAlt : 'Video thumbnail image'}
                        />
                        <button
                            aria-label="Click image to play video"
                            className="video-block-poster-trigger"
                            onClick={handlePosterClick}
                        >
                            <PlayVideoIcon />
                        </button>
                    </div>
                )}
                {posterImage && !hidePoster && hasBeenClicked ? (
                    <div
                        className="video-block-builder-embed"
                        dangerouslySetInnerHTML={{ __html: props.contentAutoplay }}
                    />
                ) : posterImage && hidePoster ? (
                    <div
                        className="video-block-builder-embed no-poster"
                        dangerouslySetInnerHTML={{ __html: props.content }}
                    />
                ) : (
                    !posterImage && (
                        <div
                            className="video-block-builder-embed no-poster"
                            dangerouslySetInnerHTML={{ __html: props.content }}
                        />
                    )
                )}
            </div>
        );
    },
    VideoSkeleton
);